import RuntimeChildrenRow from "./RuntimeChildrenRow";
import MagicChildrenRowOps from "./MagicChildrenRowOps.vue";
import { VNode } from "vue";

export default {
  name: "RuntimeFragment",
  functional: true,
  props: {
    origin: {
      type: String,
      default: ""
    },
    tableName: {
      type: String,
      default: ""
    },
    tableProperties: {
      type: String,
      default: ""
    },
    tableId: {
      type: String,
      default: ""
    }
  },
  inject: {
    options: {
      from: "htmlOptions"
    }
  },
  render(h: any, context: any) {
    const config = context.injections.options as {
      isHtml: boolean;
      model: any;
      options: {
        widgets: App.WebForm.Widget[];
      };
    };

    const parent = config.options.widgets.find(
      (d) => d.property.propertyName === context.props.tableName
    ) as App.WebForm.ChildrenTableWidget;
    const widgets = parent.widgetList;
    const vnodes: VNode[] = [];

    widgets.forEach((d, i) => {
      const widget = d[0];
      const loop = widget.loop || "";
      const vnode = h(
        RuntimeChildrenRow,
        {
          props: {
            origin: context.props.origin,
            tableProperties: context.props.tableProperties,
            tableName: context.props.tableName,
            tableId: context.props.tableId,
            loop: loop,
            config,
            widgets: widgets[i],
            row: i
          }
        },
        [
          h(MagicChildrenRowOps, {
            props: {
              origin: context.props.origin,
              tableProperties: context.props.tableProperties,
              tableName: context.props.tableName,
              tableId: context.props.tableId,
              loop: loop,
              widgets: widgets[i],
              config,
              row: i
            }
          })
        ]
      );
      vnodes.push(vnode);
    });

    return vnodes;
  }
};

